import { createRESTStore } from "@stores/shared/createRESTStore";
import API from "@config/shared/api-paths";
import apiClient from "@services/api/apiClient";

const useAppStore = createRESTStore({
  entityName: "apps",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.APPS,
    get: API.BASE + API.FRONTEND.APPS,
  },
  processResponse: {
    fetch: (data) => data.items,
    get: (data) => data,
  },
  initialState: [],

  additionalActions: (set, get) => ({
    appData: null,
    fetchingItem: false,

    getAppData: async (id) => {
      set({ fetchingItem: true, itemErrorStatus: null });
      try {
        const result = await apiClient.get(get().apiPaths.get + "/" + id);
        const itemData = result.data || result;
        set({ appData: itemData, fetchingItem: false });
        return itemData;
      } catch (error) {
        // Same contract as createRESTStore.getItem: 403 → /403 on the page.
        set({ fetchingItem: false, itemErrorStatus: error?.status ?? null });
        console.log(error);
      }
    },
  }),
});

export default useAppStore;
